<template>
  <div>
    <CRUDCriteria :showReset="true" :showSearch="false" :showAdditionalActions="true">
      <template v-slot:criteriaRows>
        <div class="mt-4 ml-6 mr-6 mb-0 pa-0">
          <v-row class="row">
            <v-col
              cols="1"
              class="pt-0 pb-0 ma-0 payment-criteria-dropdown"
              id="paymentCriteriaDropdown"
            >
              <CommonDropDowns
                :isItFiscalYear="true"
                :fiscalYearValue="criteriaState.fiscalYear"
                @change="dataFromCommonDropDowns"
              />
            </v-col>
            <v-col
              cols="2"
              class="pt-0 pb-0 ma-0 payment-criteria-date-control"
              id="paymentCriteriaDateControl"
            >
              <ClarionDateControl
                class="input-text-size"
                label="Filter Date"
                v-model="criteriaState.payDate"
                :isToggle="false"
                @input="val => searchByTimeOutClarionDate(val, 'payDate')"
              />
            </v-col>
            <v-col
              cols="2"
              class="pt-0 pb-0 ma-0 mt-n2 payment-criteria-tax-check-recon-wkst-col"
              id="paymentCriteriaTaxCheckReconWkstCol"
            >
              <SimpleMultiSelect
                class="payment-criteria-tax-check-recon-wkst-select"
                id="paymentCriteriaTaxCheckReconWkstSelect"
                label="Workstation"
                :items="criteriaState.criteriaWkst"
                :item-list="paymentWkstNumList"
                @selected-items="val => workStations('criteriaWkst', val)"
              />
            </v-col>
            <v-col cols="2" class="pt-0 pb-0 ma-0" v-if="checkTheUserIsTaxAdminForWkstOverride">
              <v-checkbox
                dense
                v-model="criteriaState.overrideWkst"
                class="mt-n4 shrink ma-0 input-text-size"
                hide-details
                label="Override wkst for payment entry"
              />
            </v-col>
            <v-col
              cols="2"
              class="payment-criteria-payment-number"
              id="paymentCriteriaPaymentNumber"
            >
              <v-text-field
                class="input-text-size payment-criteria-payment-number-input"
                id="paymentCriteriaPaymentNumberInput"
                v-model.number="criteriaState.paymentNumber"
                label="Payment #"
                @input="searchByTimeOut('paymentNumber')"
                type="number"
              />
            </v-col>
            <v-col cols="2" class="payment-criteria-business-date" id="paymentCriteriaBusinessDate">
              <ClarionDateControl
                class="input-text-size payment-criteria-business-date-input"
                id="paymentCriteriaBusinessDateInput"
                label="Business Date for payment entry"
                v-model="onBussinessChangeDate"
                @blurred="handleBussDateFY"
                :isToggle="false"
              />
            </v-col>
            <v-col cols="1" class="pt-0 pb-0 ma-0">
              <v-btn
                class="input-text-size"
                text
                color="blue darken-1"
                @click="handleBusinessDate()"
                >Save</v-btn
              >
            </v-col>
          </v-row>
          <v-expansion-panels class="mb-4" @change="expandPanelClicked">
            <v-expansion-panel>
              <v-expansion-panel-header class="ma-n1">
                <b class="input-text-size">Search Payments</b>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row class="row">
                  <v-col cols="2" class="pt-0 pb-0 ma-0 input-text-size">
                    <ClarionDateControl
                      class="input-text-size"
                      @input="searchByTimeOutClarionDate"
                      v-model="criteriaState.fromDate"
                      :isToggle="false"
                      label="From Date"
                    />
                  </v-col>
                  <v-col cols="2" class="pt-0 pb-0 ma-0 input-text-size">
                    <ClarionDateControl
                      class="input-text-size"
                      @input="searchByTimeOutClarionDate"
                      v-model="criteriaState.toDate"
                      :isToggle="false"
                      label="To Date"
                    />
                  </v-col>
                  <v-col cols="2" class="pt-0 pb-0 ma-0 input-text-size">
                    <CommonDropDowns
                      :isItTaxYearWithoutAllYears="true"
                      :addTaxYearEmpty="true"
                      :taxYearValue="criteriaState.taxYear"
                      @change="dataFromCommonDropDowns"
                    />
                  </v-col>
                  <v-col cols="2" class="pt-0 pb-0 ma-0">
                    <v-text-field
                      class="input-text-size"
                      label="Tax ID"
                      v-model.number="criteriaState.taxId"
                      type="number"
                      @input="searchByTimeOut"
                    />
                  </v-col>
                  <v-col cols="2" class="pt-0 pb-0 ma-0">
                    <v-text-field
                      class="input-text-size"
                      label="Receipt #"
                      v-model.number="criteriaState.reciept"
                      @input="searchByTimeOut"
                      type="number"
                    />
                  </v-col>
                  <v-col cols="2" class="pt-0 pb-0 ma-0">
                    <CommonDropDowns
                      class="mt-n3 mr-1"
                      :isItTaxDistrict="true"
                      @change="dataFromCommonDropDowns"
                      :taxDistrictValue="criteriaState.schoolDistrict"
                    />
                  </v-col>
                </v-row>
                <v-row class="row">
                  <v-col cols="2" class="pt-0 pb-0 ma-0">
                    <v-select
                      class="input-text-size"
                      v-model="criteriaState.paymentType"
                      hide-details
                      dense
                      :items="formattedPaymentType()"
                      item-text="label"
                      item-value="value"
                      @change="searchByCriteria"
                      label="Payment Type"
                    />
                  </v-col>
                  <v-col cols="2" class="pt-0 pb-0 ma-0">
                    <v-text-field
                      class="input-text-size"
                      label="Tax Amount"
                      v-model.number="criteriaState.taxAmt"
                      @input="searchByTimeOut"
                      type="number"
                    />
                  </v-col>
                  <v-col cols="2" class="pt-0 pb-0 ma-0">
                    <v-text-field
                      class="input-text-size"
                      label="Payment Amount"
                      v-model.number="criteriaState.amount"
                      @input="searchByTimeOut"
                      type="number"
                    />
                  </v-col>
                  <v-col cols="2" class="pt-0 pb-0 ma-0">
                    <v-text-field
                      class="input-text-size"
                      label="Paid By"
                      v-uppercase="globalSettingItem.conEverythingToCaps"
                      v-model="criteriaState.paidBy"
                      @input="searchByTimeOut"
                    />
                  </v-col>
                  <v-col cols="2" class="pt-0 pb-0 ma-0">
                    <v-text-field
                      class="input-text-size payment-criteria-created-by"
                      id="paymentCriteriaCreatedBy"
                      label="Created By"
                      v-model="criteriaState.createdBy"
                      @input="searchByTimeOut"
                    />
                  </v-col>
                  <v-col cols="2" class="pt-0 pb-0 ma-0 input-text-size">
                    <ClarionDateControl
                      class="input-text-size payment-criteria-created-on"
                      v-model="criteriaState.createdOn"
                      :isToggle="false"
                      :isIsoDate="true"
                      @input="searchByTimeOutClarionDate"
                      label="Created Date"
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </template>
      <template v-slot:additionalActions>
        <v-row dense>
          <v-col cols="4" class="pt-0">
            <v-btn
              class="input-text-size payment-criteria-action-post-dialog-btn"
              id="paymentCriteriaActionPostDialogBtn"
              text
              color="blue darken-1"
              :disabled="isSuperAdmin"
              @click="postPaymnetDialog"
            >
              Post Payments to tax Roll
            </v-btn>
          </v-col>
          <v-col cols="4" class="pt-0" v-if="!isPayrixGateway">
            <v-btn
              class="input-text-size payment-criteria-action-forte-data-manager-dialog-btn"
              id="paymentCriteriaActionForteDataManagerDialogBtn"
              text
              color="blue darken-1"
              :disabled="isSuperAdmin"
              @click="openForteDataManagerDialog"
            >
              Import WEB Payments
            </v-btn>
          </v-col>
          <v-col cols="4" class="pt-0 pb-2" v-if="isPayrixGateway">
            <v-btn
              class="input-text-size"
              text
              color="blue darken-1"
              :disabled="false"
              @click="openPayrixDataManagerDialog"
            >
              Import WEB Payments
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </CRUDCriteria>
    <v-dialog v-model="isPostDialog" max-width="500" class="input-text-size">
      <v-card>
        <v-card-title class="input-text-size payment-criteria-post-dialog-header">
          <span>Posting Payments to Tax Roll</span>
          <v-spacer></v-spacer>
          <v-btn
            v-if="hasPostingErrors"
            class="input-text-size"
            text
            color="blue darken-1"
            @click="printPostingErrors"
          >Print Errors</v-btn>
        </v-card-title>
        <v-card-text class="input-text-size">
          <v-row>
            <v-col cols="5">
              <ClarionDateControl
                class="input-text-size"
                label="Business Date"
                :isToggle="false"
                v-model="criteriaState.postingPayDate"
                @input="handlePreErrorPosting"
              />
            </v-col>
            <v-col cols="5" class="mt-n3">
              <SimpleMultiSelect
                id="tax-check-recon-criteria-wkst"
                label="Workstation #"
                :items="criteriaState.workstation"
                :item-list="paymentWkstNumList"
                @selected-items="val => workStations('workstation', val)"
              />
            </v-col>
          </v-row>
          <v-row>
            <table>
              <tbody>
                <div style="color: green;" v-if="noErrorFlag">
                  No error found
                </div>
                <div style="color: red;" v-if="misMatchItemsList.length">
                  The total of payments does not equal the total amount due
                </div>
                <div style="color: red;" v-if="isThereAnyPaymentAuditsNotApproved">
                  Unapproved audit found. Please review and then attempt to post again for this
                  date.
                </div>
                <div style="color: red;" v-for="data in misMatchItemsList" :key="data.no">
                  <tr>
                    <td>{{ data.no }}) WKST#: {{ data.wkstno }}, Payment#: {{ data.payNo }}</td>
                  </tr>
                </div>

                <div style="color: red;" v-for="data in overPayItemsList" :key="data.no">
                  <tr>
                    <td>
                      {{ data.no }}) Payment#: {{ data.payNo }} Receipt#: {{ data.reciept }} results
                      in an overpayment on tax record: {{ data.taxIdWithYear }}
                    </td>
                  </tr>
                </div>
              </tbody>
            </table>
          </v-row>
          <p style="color: red;" class="text-center mt-5">{{ postingErrorMsg }}</p>
          <p v-if="!!postingErrorMsg" class="text-center mt-n3">Current Posting Period</p>
          <p v-if="!!postingErrorMsg" class="text-center mt-n3 mb-n4">
            From Date: {{ taxSettingItem.curPostPerFromDate }}, To Date:
            {{ taxSettingItem.curPostPerToDate }}
          </p>
        </v-card-text>
        <v-card-actions class="input-text-size flex">
          <v-btn
            class="input-text-size"
            text
            color="blue darken-1"
            @click="handlePreErrorPosting('checkPosting')"
            :disabled="
              !!misMatchItemsList.length ||
                !!postingErrorMsg ||
                disablePreErrorPostingBtn ||
                isThereAnyPaymentAuditsNotApproved
            "
            >Pre-Post Error Check</v-btn
          >
          <v-btn
            class="input-text-size"
            text
            color="blue darken-1"
            @click="handlePostingDate()"
            :disabled="
              !!misMatchItemsList.length ||
                !!postingErrorMsg ||
                disablePostingBtn ||
                isThereAnyPaymentAuditsNotApproved
            "
            >Post Payments
          </v-btn>
          <v-btn class="input-text-size" text color="blue darken-1" @click="closePostDialog"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isForteDataManagerDialog" max-width="500">
      <v-card>
        <v-card-title class="input-text-size">Forte Data Manager</v-card-title>
        <v-card-text>
          <ForteDataManager :baseCrudKey="baseCrudKey" @searchByCriteria="searchByCriteria" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="isForteDataManagerDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isPayrixDataManagerDialog" max-width="500" class="input-text-size">
      <v-card>
        <v-card-title class="input-text-size flex">Import WEB Payments</v-card-title>
        <v-card-text class="input-text-size">
          <PayrixDataManager
            :baseCrudKey="baseCrudKey"
            @searchByCriteria="searchByCriteria"
            :parentBusinessDate="onBussinessChangeDate"
          />
        </v-card-text>
        <v-card-actions class="input-text-size flex">
          <v-btn
            class="input-text-size"
            text
            color="blue darken-1"
            @click="isPayrixDataManagerDialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isSuccessPopup" max-width="400" persistent>
      <v-card>
        <v-card-title class="input-text-size justify-center">Success</v-card-title>
        <v-card-text class="input-text-size text-center">
          {{ successPopupMessage }}
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn class="input-text-size" color="blue darken-1" text @click="closeSuccessPopup">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isErrorPopup" max-width="400" persistent>
      <v-card>
        <v-card-title class="input-text-size justify-center error--text">Error</v-card-title>
        <v-card-text class="input-text-size text-center">
          {{ errorPopupMessage }}
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn class="input-text-size" color="blue darken-1" text @click="closeErrorPopup">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  mapMutations, mapGetters, mapActions, mapState,
} from 'vuex';
import ClarionDateControl from '@/components/common/ClarionDateControl.vue';
import CommonDropDowns from '../common-utils/CommonDropDowns.mixin.vue';
import CRUDCriteria from '../../common/base/crud-2.0/CRUDCriteria.vue';
import { SEARCH_DEBOUNCE_TIMER } from '../common-utils/constants';
import { makeCriteriaStateNullIfEmptyString } from '../common-utils/CommonTaxFunctionalities';
import SimpleMultiSelect from '../../common/base/SimpleMultiSelect.vue';
import {
  toIsoDate, toShortDate, toFiscalYear, isFiscalYearWithinPostingPeriod,
} from '../../../util/shared/tmc-global';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';
import { isAuthorised } from '../../../store/auth/token';
import { authRoles } from '../../../router/roleGroups';
import { amountToNumber } from '../../../util/shared/vue-global';
import { getWorkstationNumber } from '../../../util/workstation-util';
import { clients } from '../../../util/clients';
import ForteDataManager from './utils/forteUtil/ForteDataManager.vue'; // Imported ForteDataManager component
import PayrixDataManager from './utils/payrixUtil/PayrixDataManager.vue';
import { getRawJwt } from '../../../util/jwt';
import { queryStringCalcForPrePostErrorReport } from './Reports/report-util';
import {
  globalScope,
  paymentConfigScope,
} from '../../../util/shared/system-config-scopes';
import { isDateWithinPostingPeriod } from '../common-utils/tax-common.util';
import '../../../assets/style.css';

const { backendRest } = clients.direct;

export default {
  mixins: [GlobalToCaps],
  data() {
    return {
      baseCrudKey: 'paymentTransactionList',
      isPostDialog: false,
      isForteDataManagerDialog: false, // Added data property for Forte Data Manager dialog
      delayTimerId: null,
      delayTimerIdForPst: null,
      disablePostingBtn: true,
      noErrorFlag: false,
      disablePreErrorPostingBtn: false,
      postingErrorMsg: '',
      businessDate: null,
      wkstNumber: getWorkstationNumber(),
      isPayrixDataManagerDialog: false,
      isThereAnyPaymentAuditsNotApproved: false,
      isSuccessPopup: false,
      successPopupMessage: '',
      isErrorPopup: false,
      errorPopupMessage: '',
    };
  },
  props: {
    postPayment: {
      type: Function,
    },
    preErrorCheckPayments: {
      type: Function,
    },
  },
  components: {
    ClarionDateControl,
    CommonDropDowns,
    CRUDCriteria,
    SimpleMultiSelect,
    ForteDataManager, // Registered ForteDataManager component
    PayrixDataManager,
  },
  created() {
    this.initCriteria();
  },
  computed: {
    ...mapGetters('auth/token', ['isTaxAdminAccessible']),
    ...mapState({
      paymentWkstNumList: (state) => state.tax.taxPayment.paymentWkstNumList || [],
      misMatchItemsList: (state) => state.tax.taxPayment.misMatchItemsList || [],
      paymentDialogBusinessDate: (state) => state.tax.taxPayment.paymentDialogBusinessDate || '',
      paymentsFilterDate: (state) => state.tax.taxPayment.paymentsFilterDate || '',
      overPayItemsList: (state) => state.tax.taxPayment.overPayItemsList || [],
      paymentTypes: (state) => state.enums.TaxPaymentTypeEnum || [],
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem,
      criteriaForPstPay: (state) => state.base.crud.criteria.paymentTransactionList,
      taxYearRange: (state) => state.tax.taxCommon.taxYearList,
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
      paymentSettingItem: (state) => state.SystemConfig.paymentSettingItem || {},
      odSettingItem: (state) => state.SystemConfig.odSettingItem || {},
    }),
    ...mapGetters('base/crud', ['criteria']),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    onBussinessChangeDate: {
      get() {
        return this.paymentDialogBusinessDate;
      },
      set(value) {
        this.setPaymentDialogBusinessDate(value);
      },
    },
    onPaymentFilterChangeDate: {
      get() {
        return this.paymentsFilterDate;
      },
      set(value) {
        this.setPaymentsFilterDate(value);
      },
    },
    isSuperAdmin() {
      if (this.paymentSettingItem.onlyAdminsCanPostPayments) {
        const isAdmin = isAuthorised(authRoles.SuperAdmin) || isAuthorised(authRoles.PaymentAdmin) || isAuthorised(authRoles.TaxAdmin);
        if (isAdmin) return false;
        return true;
      }
      return false;
    },
    isPayrixGateway() {
      return this.odSettingItem.selectedGateway === 'payrix';
    },
    hasPostingErrors() {
      return !!this.misMatchItemsList.length
        || !!this.overPayItemsList.length
        || !!this.postingErrorMsg
        || this.isThereAnyPaymentAuditsNotApproved;
    },
    checkTheUserIsTaxAdminForWkstOverride() {
      if (this.paymentSettingItem.restrictWorkstationOverrideToTaxAdminsOnly) {
        const userRole = this.isTaxAdminAccessible;
        return userRole;
      }
      return true;
    },
  },
  methods: {
    ...mapActions('tax/taxPayment', ['loadPaymentsWkstList']),
    ...mapMutations('base/crud', ['setCriteria', 'setWkstList']),
    ...mapMutations('tax/taxPayment', [
      'setMisMatchItemsList',
      'setOverPayItemsList',
      'setPaymentDialogBusinessDate',
      'setPaymentsFilterDate',
    ]),
    ...mapActions('SystemConfig', ['loadConfig', 'upsertConfigSpecificFields']),
    ...mapActions(['flashSuccess', 'flashError']),
    initCriteria() {
      this.criteriaState.criteriaWkst = [amountToNumber(this.wkstNumber)];
      this.criteriaState.workstation = [amountToNumber(this.wkstNumber)];
      this.loadPaymentsWkstList();
    },
    formattedPaymentType() {
      const nullRecord = [{ label: '', value: null }];
      const paymentTypes = this.paymentTypes.map((el) => ({
        label: el.description,
        value: el.name,
      }));
      return [...nullRecord, ...paymentTypes];
    },
    searchByTimeOut(fromWhere) {
      clearTimeout(this.delayTimerId);
      this.delayTimerId = setTimeout(async () => {
        if (fromWhere === 'paymentNumber' && this.criteriaState.paymentNumber) {
          this.criteriaState.criteriaWkst = [...this.paymentWkstNumList];
        }
        this.searchByCriteria(fromWhere);
      }, SEARCH_DEBOUNCE_TIMER);
    },
    searchByTimeOutClarionDate(val, fromWhere) {
      clearTimeout(this.delayTimerId);
      if ((val && val.includes('-')) || !val) {
        this.delayTimerId = setTimeout(async () => {
          this.searchByCriteria();
          if (fromWhere === 'payDate') {
            this.onPaymentFilterChangeDate = val;
            // localStorage.setItem('tax_payment_filter_date', val);
          }
        }, SEARCH_DEBOUNCE_TIMER);
      }
    },
    searchByCriteria(fromWhere) {
      const returnCriteria = makeCriteriaStateNullIfEmptyString(this.criteriaState);
      // when payment number is there delete the payDate, so it wont affect the search
      if (fromWhere === 'paymentNumber') delete returnCriteria.payDate;
      this.criteriaState = { ...returnCriteria };
      this.$emit('loadCRUDList', fromWhere);
    },
    postPaymnetDialog() {
      // reseting flags
      this.setOverPayItemsList([]);
      this.setMisMatchItemsList([]);
      this.isThereAnyPaymentAuditsNotApproved = false;
      this.disablePostingBtn = true;
      this.disablePreErrorPostingBtn = false;
      this.noErrorFlag = false;
      const payDate = this.criteriaForPstPay.payDate
        ? this.criteriaForPstPay.payDate
        : toShortDate();
      this.criteriaState.postingPayDate = payDate;
      this.postingErrorMsg = '';
      this.isPostDialog = true;
      // eslint-disable-next-line max-len
      // this.handlePreErrorPosting('checkPosting'); // Call to get real-time values when dialog opens
      this.criteriaState.workstation = this.paymentWkstNumList;
    },
    closePostDialog(items, fromWhere) {
      if (items.statusCode === 200) {
        if (fromWhere === 'errorCheckPayments') {
          this.disablePostingBtn = false;
          this.noErrorFlag = true;
        } else {
          this.isPostDialog = false;
          this.successPopupMessage = items.message || 'Payments posted successfully!';
          this.isSuccessPopup = true;
        }
      } else if (items.statusCode === 201) {
        // for amt mismatch
        this.setMisMatchItemsList(items.errorMsg);
      } else if (items.statusCode === 202) {
        // for over payment
        this.setOverPayItemsList(items.errorMsg);
        this.disablePostingBtn = false;
      } else if (items.statusCode === 203) {
        // for paymentaudits not approved
        this.isThereAnyPaymentAuditsNotApproved = true;
      } else if (items.statusCode === 404 || items.statusCode === 500) {
        // for no payments found or error
        this.isPostDialog = false;
        this.errorPopupMessage = items.message || 'An error occurred';
        this.isErrorPopup = true;
      } else {
        this.isPostDialog = false;
        this.setOverPayItemsList([]);
        this.setMisMatchItemsList([]);
        this.isThereAnyPaymentAuditsNotApproved = false;
      }
    },
    workStations(variableName, val) {
      this.criteriaState[variableName] = val;
      if (variableName === 'criteriaWkst') {
        clearTimeout(this.delayTimerId);
        this.delayTimerId = setTimeout(() => {
          this.searchByCriteria();
        }, SEARCH_DEBOUNCE_TIMER);
      }
    },
    expandPanelClicked(val) {
      if (val === 0) {
        // when the panel is clicked as it is 1st panel, so it will be 0,
        // thats why i am checking for 0
        // when the click the expand we need to empty payDate, paymentNumber, add all wkst
        this.criteriaState.payDate = null;
        this.criteriaState.paymentNumber = null;
        this.criteriaState.criteriaWkst = this.paymentWkstNumList;
      }
    },
    dataFromCommonDropDowns(val, whichField) {
      this.criteriaState[whichField] = val;
      this.searchByCriteria();
    },
    handleBussDateFY(val) {
      // keep Fiscal Year in sync with the Business Date for payment entry
      if (val) this.criteriaState.fiscalYear = toFiscalYear(new Date(val));
    },
    async handleBusinessDate() {
      const bussDate = this.onBussinessChangeDate;
      // if the bussDate doesn't match the fiscal year, then don't save it
      if (toFiscalYear(new Date(bussDate)) !== this.criteriaState.fiscalYear) {
        this.flashError('Business Date does not match the fiscal year');
        return;
      }
      if (!isFiscalYearWithinPostingPeriod(this.criteriaState.fiscalYear)) {
        this.flashError('Business Date results in a fiscal year outside the current posting period');
        return;
      }
      const bussDateChangeIndividually = this.paymentSettingItem.changeBussDateIndividually;
      // when they save if the 'changeBussDateIndividually' is false save that in global-setting
      if (bussDate && !bussDateChangeIndividually) {
        const payload = {
          calledScope: globalScope.scope,
          item: globalScope.buildSpecificItem(this.globalSettingItem.id, {
            [globalScope.specificFields.businessDate]: bussDate,
          }),
        };
        await this.upsertConfigSpecificFields(payload);
        this.flashSuccess('Business Date for payment entry is successfully updated');
      } else if (bussDate && bussDateChangeIndividually) {
        localStorage.setItem('businessDateForPaymentEntry', bussDate);
        this.flashSuccess('Business Date for payment entry is successfully updated');
      }
    },
    handlePostingDate() {
      this.disablePostingBtn = true;
      this.postPayment();
      // when they post payments update latestPostDate in payments-setting, the posting
      // date should be greater than the latestPostDate date
      if (this.paymentSettingItem.latestPostDate) {
        const formattedPayDate = new Date(this.criteriaState.postingPayDate);
        const formattedLatestPostDate = new Date(this.paymentSettingItem.latestPostDate);
        formattedLatestPostDate.setDate(formattedLatestPostDate.getDate() - 1);
        if (formattedPayDate > formattedLatestPostDate) {
          const payload = {
            calledScope: paymentConfigScope.scope,
            item: paymentConfigScope.buildSpecificItem(this.paymentSettingItem.id, {
              [paymentConfigScope.specificFields.latestPostDate]: this.criteriaState.postingPayDate,
            }),
          };
          this.upsertConfigSpecificFields(payload);
        }
      } else {
        const payload = {
          calledScope: paymentConfigScope.scope,
          item: paymentConfigScope.buildSpecificItem(this.paymentSettingItem.id, {
            [paymentConfigScope.specificFields.latestPostDate]: this.criteriaState.postingPayDate,
          }),
        };
        this.upsertConfigSpecificFields(payload);
      }
    },
    handlePreErrorPosting(val) {
      clearTimeout(this.delayTimerIdForPst);
      let toIsoDt = toIsoDate(val);
      if (val === 'checkPosting') toIsoDt = toIsoDate(this.criteriaState.postingPayDate);
      this.delayTimerIdForPst = setTimeout(() => {
        // resetting
        this.postingErrorMsg = '';
        this.setMisMatchItemsList([]);
        this.isThereAnyPaymentAuditsNotApproved = false;
        this.disablePreErrorPostingBtn = false;

        if (!this.taxSettingItem.curPostPerFromDate || !this.taxSettingItem.curPostPerToDate) {
          this.postingErrorMsg = 'Required Posting Period from Tax-setting';
        } else if (isDateWithinPostingPeriod(toIsoDt, this.taxSettingItem)) {
          this.postingErrorMsg = '';
          if (val === 'checkPosting') {
            this.disablePreErrorPostingBtn = true;
            this.preErrorCheckPayments();
          }
        } else {
          this.postingErrorMsg = 'The Business Date has to be within the posting period';
        }
      }, SEARCH_DEBOUNCE_TIMER);
    },
    openForteDataManagerDialog() {
      // Added method to open Forte Data Manager dialog
      this.isForteDataManagerDialog = true;
    },
    openPayrixDataManagerDialog() {
      this.isPayrixDataManagerDialog = true;
    },
    printPostingErrors() {
      const jwt = getRawJwt();
      const criteria = {
        ...this.criteriaState,
        flagForAuditApprovedOrNot:
        this.paymentSettingItem.auditsMustBeApprovedBeforePosting || false,
      };
      const queryString = queryStringCalcForPrePostErrorReport({
        criteria,
        token: jwt,
      });
      const toUrl = `${backendRest.defaults.baseURL}/payments/pre-post-error-report${queryString}`;

      window.open(toUrl);
    },
    closeSuccessPopup() {
      this.isSuccessPopup = false;
      this.successPopupMessage = '';
    },
    closeErrorPopup() {
      this.isErrorPopup = false;
      this.errorPopupMessage = '';
    },
  },
};
</script>

<style scoped>
.row {
  margin: -1rem !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
.label {
  font-size: 0.85rem;
}
.flex {
  display: flex;
  justify-content: center;
}
.payment-criteria-post-dialog-header {
  display: flex;
  align-items: center;
}
</style>
